import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChatSessionItem } from '../../../types/chat-session.types';
import { ChatSessionListComponent } from '../../session-list/chat-session-list/chat-session-list.component';

@Component({
    selector: 'chat-search-sessions',
    standalone: true,
    imports: [CommonModule, ChatSessionListComponent],
    templateUrl: './chat-search-sessions.component.html',
    styleUrls: ['./chat-search-sessions.component.scss'],
})
export class ChatSearchSessionsComponent {
    @Input() public sessions: ChatSessionItem[] = [];
    @Output() public sessionSelected = new EventEmitter<string>();
}
